var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useContext, useEffect } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Dropdown, DropdownField, MenuItem, FormLabel, TextField, IconButton, Button, Link, FormStatusMessage, } from '@one-thd/sui-atomic-components';
import { Search as SearchIcon, Close as CloseIcon } from '@one-thd/sui-icons';
import { ERR_GENERIC } from '../../constants/response-error-messages';
import { validationSchema } from './validation';
import { SEARCH_BY, SEARCH_TYPE_VALUES } from '../../constants/search';
export var UsersSearch = function (_a) {
    var _b = _a.values, currentType = _b.type, currentValue = _b.value, onSubmit = _a.onSubmit;
    var channel = useContext(ExperienceContext).channel;
    var isMobile = channel === 'mobile';
    var _c = useState(false), showClearBtn = _c[0], setShowClearBtn = _c[1];
    var _d = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            searchType: currentType,
            searchValue: currentValue === 'default' ? '' : currentValue,
        },
        mode: 'onTouched',
    }), register = _d.register, handleSubmit = _d.handleSubmit, watch = _d.watch, setValue = _d.setValue, reset = _d.reset, control = _d.control;
    var _e = useState(null), errorMsg = _e[0], setErrorMsg = _e[1];
    var _f = watch(), searchType = _f.searchType, searchValue = _f.searchValue;
    var isDefaultType = searchType === 'default';
    var isDropdownTypes = searchType === 'role' || searchType === 'status';
    var dropdownPlaceholders = {
        role: 'Choose a Role',
        status: 'Choose a Status',
    };
    useEffect(function () {
        if (!isDefaultType) {
            setShowClearBtn(true);
        }
    }, []);
    var onClearError = function () { return setErrorMsg(null); };
    var onClearSearch = function () {
        reset({
            searchType: 'default',
            searchValue: '',
        });
        handleSubmit(onSubmitForm)();
    };
    var onSubmitForm = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var isDefaultTypeValue;
        return __generator(this, function (_a) {
            isDefaultTypeValue = values.searchType === 'default';
            if (!isDefaultTypeValue && !values.searchValue) {
                return [2 /*return*/, null];
            }
            onClearError();
            return [2 /*return*/, onSubmit(values)
                    .then(function () {
                    if (!isDefaultTypeValue) {
                        setShowClearBtn(true);
                    }
                    else {
                        setShowClearBtn(false);
                    }
                })
                    .catch(function () {
                    setErrorMsg(ERR_GENERIC);
                })];
        });
    }); };
    var clearSearchBtn = (React.createElement(Link, { component: "button", type: "button", onClick: onClearSearch }, "Clear Search"));
    return (React.createElement("form", { className: "sui-grid sui-grid-cols-1 sui-gap-y-4 md:sui-grid-cols-6 md:sui-gap-x-6 xl:sui-gap-x-8 2xl:sui-grid-cols-5 2xl:sui-gap-x-2", onSubmit: handleSubmit(onSubmitForm) },
        React.createElement("div", { className: "sui-col-span-3 2xl:sui-col-span-2" },
            React.createElement(FormLabel, { htmlFor: "search-by-dropdown" }, "Search By"),
            React.createElement(Controller, { name: "searchType", key: searchType, control: control, render: function (_a) {
                    var field = _a.field;
                    var onChange = field.onChange, ref = field.ref, rest = __rest(field, ["onChange", "ref"]);
                    return (React.createElement(Dropdown, __assign({ id: "search-by-dropdown", maxItems: 3, placeholder: "Select Field", onChange: function (event) {
                            onClearError();
                            setValue('searchValue', '');
                            onChange(event);
                        } }, rest, { "data-testid": "search-by-dropdown" }), Object.entries(SEARCH_BY).map(function (_a) {
                        var key = _a[0], value = _a[1];
                        return (React.createElement(MenuItem, { key: key, value: key }, value));
                    })));
                } }),
            !isMobile && showClearBtn && (React.createElement("div", { className: "sui-mt-2" }, clearSearchBtn))),
        React.createElement("div", { className: "sui-col-span-3 2xl:sui-col-span-".concat(isDropdownTypes ? 2 : 3) },
            !isMobile && (React.createElement("div", { className: "sui-invisible" },
                React.createElement(FormLabel, null, "\u00A0"))),
            isDropdownTypes ? (React.createElement(Controller, { name: "searchValue", control: control, render: function (_a) {
                    var field = _a.field;
                    var onChange = field.onChange, ref = field.ref, rest = __rest(field, ["onChange", "ref"]);
                    return (React.createElement(DropdownField, __assign({ maxItems: 3, fullWidth: true, status: errorMsg && 'error', key: searchType, labelProps: {
                            component: function () { return null; },
                        }, dropdownProps: {
                            placeholder: dropdownPlaceholders[searchType],
                        }, onChange: function (event) {
                            onChange(event);
                            handleSubmit(onSubmitForm)();
                        } }, rest), Object.entries(SEARCH_TYPE_VALUES[searchType]).map(function (_a) {
                        var key = _a[0], value = _a[1];
                        return (React.createElement(MenuItem, { key: key, value: key }, value));
                    })));
                } })) : (React.createElement("div", { className: "sui-flex sui-items-end" },
                React.createElement(TextField, { name: "searchValue", fullWidth: true, placeholder: !isDefaultType ? 'Enter full or partial name' : '', type: "search", disabled: isDefaultType, status: errorMsg && 'error', FormLabelProps: {
                        component: function () { return null; },
                    }, InputProps: __assign(__assign({}, register('searchValue')), { disableStatus: true, style: {
                            backgroundColor: 'var(--UI-Background-Fill-Background-Subtle, #F4F4F4)',
                        }, inputProps: {
                            'data-testid': 'usersSearchInput',
                        }, endAdornment: !searchValue ? (React.createElement(SearchIcon, { color: "medium", style: {
                                background: 'transparent',
                            }, size: "small" })) : (React.createElement(IconButton, { onClick: function () { return setValue('searchValue', ''); }, icon: CloseIcon, style: {
                                background: 'transparent',
                            }, iconsize: "small", "aria-label": "Clear" })) }) }),
                !isMobile && searchValue && (React.createElement("div", { className: "sui-ml-2" },
                    React.createElement(Button, { type: "submit" },
                        React.createElement(SearchIcon, { size: "small" })))))),
            errorMsg && (React.createElement(FormStatusMessage, { status: "error" }, errorMsg.message))),
        isMobile && showClearBtn && (React.createElement("div", { className: "sui-col-span-5" }, clearSearchBtn))));
};
